<script lang="ts">
    import type {PublicStatsData, TwoColumnTableData} from '../../types';
    import {pipe} from 'core/utils';
    import {byteFormatter} from 'shared/utils/pipes';
    import {getLocalization} from 'core/svelte-context/context';
    import KpStatsTwoColumnTable from '../../components/KpStatsTwoColumnTable.svelte';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    function getGeneralInfoTableData(data: PublicStatsData): TwoColumnTableData {
        return {
            firstColumnTitle: localize(/* @kp-localization commons.Nazev */ 'commons.Nazev'),
            secondColumnTitle: localize(/* @kp-localization commons.pocet */ 'commons.pocet'),
            rows: [
                {
                    label: localize(/* @kp-localization statistiky.pocetZaregistrovanychCtenaru */ 'statistiky.pocetZaregistrovanychCtenaru'),
                    value: data.stats.result.registeredReadersCount.count
                },
                {
                    label: localize(/* @kp-localization statistiky.pocetDokumentuVKnihovne */ 'statistiky.pocetDokumentuVKnihovne'),
                    value: data.stats.result.documentsCount.count
                },
                {
                    label: localize(/* @kp-localization statistiky.pocetExemplaruVKnihovne */ 'statistiky.pocetExemplaruVKnihovne'),
                    value: data.stats.result.exemplarsCount.count
                },
                {
                    label: localize(/* @kp-localization statistiky.pocetAktivnichVypujcek */ 'statistiky.pocetAktivnichVypujcek'),
                    value: data.stats.result.activeLoansCount.count
                },
                {
                    label: localize(/* @kp-localization statistiky.pocetAktivnichEVypujcek */ 'statistiky.pocetAktivnichEVypujcek'),
                    value: data.stats.result.activeELoansCount.count
                }
            ]
        }
    }

    function getFondsInfoTableData(data: PublicStatsData): TwoColumnTableData {
        return {
            firstColumnTitle: localize(/* @kp-localization commons.fond */ 'commons.fond'),
            secondColumnTitle: localize(/* @kp-localization statistiky.pocetDokumentu */ 'statistiky.pocetDokumentu'),
            rows: data.stats.result.documentsAndExemplarsCountsByFonds.counts.map((byFond) => {
                return {
                    label: byFond.name,
                    value: byFond.value.first
                }
            })
        }
    }

    function getDiskUsageInfoTableData(data: PublicStatsData): TwoColumnTableData {
        return {
            firstColumnTitle: localize(/* @kp-localization file.FileType */ 'file.FileType'),
            secondColumnTitle: localize(/* @kp-localization file.TotalSize */ 'file.TotalSize'),
            rows: data.stats.result.discSpaceConsumptionStatProvider.counts.map((diskUsage) => {
                return {
                    label: diskUsage.name.trim() ? diskUsage.name.trim() : '-',
                    value: pipe(diskUsage.value, byteFormatter(2))
                }
            })
        }
    }

    function getTotalDiskUsageSize(data: PublicStatsData): number {
        let totalSize = 0;
        data.stats.result.discSpaceConsumptionStatProvider.counts.forEach((diskUsage) => totalSize += diskUsage.value);
        return totalSize;
    }
</script>

<div class="public-stats-textual-info-container">
    <!-- General info -->
    <KpStatsTwoColumnTable title="{localize(/* @kp-localization statistiky.OverallStats */ 'statistiky.OverallStats')}"
                           tableData="{getGeneralInfoTableData(statsData)}"/>

    <!-- Fonds info -->
    <KpStatsTwoColumnTable tableData="{getFondsInfoTableData(statsData)}"
                           title="{localize(/* @kp-localization statistiky.statistikyFondu */ 'statistiky.statistikyFondu')}"/>

    <!-- Disk usage info -->
    <KpStatsTwoColumnTable tableData="{getDiskUsageInfoTableData(statsData)}"
                           title="{localize(/* @kp-localization file.DiskUsage */ 'file.DiskUsage')} ({localize(/* @kp-localization commons.Total */ 'commons.Total')}: {pipe(getTotalDiskUsageSize(statsData), byteFormatter(2))})"/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.media-queries.less";

    .public-stats-textual-info-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: @spacing-xl;
        width: 100%;

        @media (max-width: @screen-xs-max) {
            grid-template-columns: 1fr;
            gap: 36px;
        }
    }
</style>